// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3sxx0","topBottomGutter":"Layout_topBottomGutter__2JQR8"};